import { FC, memo, useState, ChangeEvent } from 'react';

import { Box } from 'ui/Box';

import { Typography } from 'ui/Typography';
import { ButtonsSet } from 'modules/RegisterModule/components/ButtonsSet';

import { InputForm } from '../InputForm';
export interface Step1Props {
  onSubmit: (text: string) => void;
  prevStep: () => void;
  employeeName: string;
}

export const Step1: FC<Step1Props> = memo(
  ({ onSubmit, prevStep, employeeName }) => {
    const [text, setText] = useState(employeeName);

    const onInput = (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value.trimStart();
      if (value.length <= 50 && !(value.endsWith(' ') && text.endsWith(' '))) {
        setText(value);
      }
    };

    return (
      <Box className="flex flex-1 flex-col items-center justify-center">
        <Typography
          variant="pSemiBold"
          className="mt-8 max-w-[44rem] text-center text-[28px] md:text-[32px]"
        >
          What would you like to name your new digital employee?
        </Typography>
        <InputForm
          onInput={onInput}
          value={text}
          placeholder="e.g. Roger, Tomas ..."
          onSubmit={onSubmit}
          disabled={text.trim().length < 1}
        />
        <ButtonsSet
          onBack={prevStep}
          onNext={() => onSubmit(text)}
          className="mt-9"
          isNextDisabled={text.trim().length < 1}
        />
      </Box>
    );
  }
);
